import { mergeStyles } from '@fluentui/react';
import React from 'react';
import { topToolbarStyle } from '../styles';

export interface TopToolbarProps {
    className?: string;
}

export const TopToolbar = (props: TopToolbarProps): JSX.Element => (<div
        className={mergeStyles(topToolbarStyle.root, props.className)}
    ><img className={mergeStyles(topToolbarStyle.logo)} src="/assets/logo-wide.svg"/></div>)